import { render } from "./index.vue?vue&type=template&id=72a35af4"
const script = {}

import "./index.vue?vue&type=style&index=0&id=72a35af4&lang=scss"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__